var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 53,
    viewBox: "0 0 42 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7 18.603V15.4583C35.7 6.92095 29.1186 0 21 0C12.8814 0 6.30001 6.92095 6.30001 15.4583V18.603C2.47807 20.3571 0.00551251 24.3232 0 28.7083V41.9583C0.00689064 48.0534 4.70384 52.9928 10.4999 53H31.5C37.2961 52.9928 41.993 48.0534 42 41.9583V28.7083C41.9946 24.3232 39.5219 20.3571 35.7 18.603ZM23.1 37.5417C23.1 38.7613 22.1598 39.75 21 39.75C19.8402 39.75 18.9 38.7613 18.9 37.5417V33.125C18.9 31.9054 19.8402 30.9167 21 30.9167C22.1598 30.9167 23.1 31.9054 23.1 33.125V37.5417ZM31.5 17.6667H10.4999V15.4584C10.4999 9.3603 15.2009 4.4167 21 4.4167C26.7991 4.4167 31.5 9.36019 31.5 15.4584V17.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.9753d013b8f9bc91967bea45008ece76.svg";
export { ForwardRef as ReactComponent };